module.exports = __webpack_public_path__ + "static/media/maera_s26ru.a2e18474.pdf";